export default "__VITE_ASSET__80d9a8b6__"